import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import {
  binLocationListAction,
  storeIdAction,
} from "../../../redux/actions/general-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  purchaseReturnEditAction,
  purchaseReturnReceiptCreateAction,
} from "../../../redux/actions/purchase-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import PurchaseBatchesPanel from "../purchase-batches-panel";
import PurchaseItemsSection from "../purchase-items-section";
import SalesPurchaseFooter from "../../sales-section/sales-purchase-footer";
import SalesPurchaseNavbar from "../../sales-section/sales-purchase-navbar";

const CreateEditViewPurReturn = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  disabled = false,
  type = "",
  page = "",
  data = {},
  payto,
  shipto,
  pageType,
  clickedplus,
  transfer=false,
}) => {
  const [heading, setHeading] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const formValuesRef = useRef(null);
  const rowData = useSelector((state) => state.invoiceRowReducer);
  const [binLocationList, setBinLocationList] = useState([]);
  const searchRef = useRef(null);
  const initialData = {
    sl_no: 1,
    item_name: "",
    item_generic_name: "",
    item_code: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_batches: "",
    // item_unit_price: 0,
    item_return_open_quantity: 0,
    quantity: 0,
    item_pack_size: 0,
    item_free_quantity: 0,
    item_discount_amount: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst: 0,
    pot_id: null,
    item_uom_id: "",
    item_manufacturer_id: "",
  };
  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    remarks: vendorDetails?.[0]?.remarks ?? "",
    cmr_balance: vendorDetails?.[0]?.cmr_balance || 0,
    is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
    prt_total_discount:
      type === "goods"
        ? orderDetail.reduce(
            (sum, item) => sum + (parseFloat(item.item_discount_amount) || 0),
            0
          )
        : vendorDetails?.[0]?.prt_total_discount || 0,
    ...(vendorDetails?.[0]?.prt_id
      ? { prt_id: vendorDetails?.[0]?.prt_id }
      : {}),
    prt_order_date: vendorDetails?.[0]?.prt_order_date
      ? moment(vendorDetails?.[0]?.prt_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    prt_document_date: vendorDetails?.[0]?.prt_document_date
      ? moment(vendorDetails?.[0]?.prt_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    prt_delivery_date: vendorDetails?.[0]?.prt_delivery_date
      ? moment(vendorDetails?.[0]?.prt_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    prt_round_off_value: vendorDetails?.[0]?.prt_round_off_value || 0,
    cmr_tcs: "",
    cmr_tds: "",
    prt_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    prt_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage || 0,
    prt_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    prt_tcs_or_tds_amount:
      vendorDetails?.[0]?.prt_tcs_or_tds_amount ||
      vendorDetails?.[0]?.tcs_or_tds_amount ||
      0,
    prt_sub_total: vendorDetails?.[0]?.prt_sub_total || 0,
    prt_total_amount: vendorDetails?.[0]?.prt_total_amount || 0,
    prt_total_gst: vendorDetails?.[0]?.prt_total_gst || 0,
    prt_order_status: vendorDetails?.[0]?.prt_order_status ?? "",

    prt_is_invoice_dis_percentage:
      vendorDetails?.[0]?.prt_is_invoice_dis_percentage ?? true,
    prt_invoice_discount: vendorDetails?.[0]?.prt_invoice_discount ?? 0,
    prt_invoice_discount_percentage:
      vendorDetails?.[0]?.prt_invoice_discount_percentage ?? 0,
    prt_pay_to_address: payto, //new
    prt_ship_to_address: shipto, //new
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.prt_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.prt_invoice_discount_percentage
      : vendorDetails?.[0]?.prt_invoice_discount,
    customer_invoice_number:
      vendorDetails?.[0]?.customer_invoice_number ?? null,
    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_name: item?.item_name,
        item_generic_name: item?.item_generic_name,
        item_code: item?.item_code,
        item_hsn: item?.item_hsn,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_uom: item?.item_uom,
        item_batches:
          type === "return"
            ? []
            : item?.itemBatchData?.map((batch) => ({
                item_batch_number: batch?.item_batch_number,
                gst_type:vendorDetails?.[0]?.gst_type,
                item_sellable_quantity:
                  parseInt(batch?.item_sellable_quantity) || 0,
                item_batch_free_quantity:
                  parseInt(batch?.item_batch_free_quantity) || 0,
                item_batch_total_effective_qauntity:
                  parseInt(batch?.item_batch_total_effective_qauntity) || 0, //new

                item_batch_total_base_purchase_rate:
                  parseFloat(batch?.item_batch_total_base_purchase_rate) || 0, //new

                item_batch_for_qauntity:
                  parseInt(batch?.item_batch_for_qauntity) || 0, //new
                item_batch_for_free_qauntity:
                  parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                item_batch_scheme_discount_percentage:
                  parseFloat(batch?.item_batch_scheme_discount_percentage) || 0, //new
                item_batch_scheme_discount_amount:
                  parseFloat(batch?.item_batch_scheme_discount_amount) || 0, //new

                item_batch_scheme_purchase_rate:
                  parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new

                item_batch_discount_percentage:
                  parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                item_batch_gen_discount_amount:
                  parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                item_batch_discounted_purchase_rate:
                  parseFloat(batch?.item_batch_discounted_purchase_rate) || 0, //new

                item_batch_purchase_rate:
                  parseFloat(batch?.item_batch_purchase_rate) || 0,
                item_batch_discount_amount: parseFloat(
                  batch?.item_batch_discount_amount
                ),
                item_batch_tax_percentage: parseFloat(
                  batch?.item_batch_tax_percentage
                ),
                item_batch_tax_amount: parseFloat(batch?.item_batch_tax_amount),
                item_batch_final_purchase_rate: parseFloat(
                  batch?.item_batch_final_purchase_rate
                ),
                item_batch_total_purchase_rate: parseFloat(
                  batch?.item_batch_total_purchase_rate
                ),
                item_batch_sgst_percentage:(batch?.item_batch_sgst_percentage||0),
                item_batch_cgst_percentage:(batch?.item_batch_cgst_percentage||0),
                item_batch_igst_percentage:(batch?.item_batch_igst_percentage||0),
                item_batch_cgst_amount:(batch?.item_batch_cgst_amount||0),
                item_batch_sgst_amount:(batch?.item_batch_sgst_amount||0),
                item_batch_igst_amount:(batch?.item_batch_igst_amount||0),
                item_batch_unit_price:
                  parseFloat(batch?.item_batch_unit_price) || 0,
                item_batch_margin_percentage:
                  parseFloat(batch?.item_batch_margin_percentage) || 0,
                item_exp_date: batch?.item_exp_date,
                item_id: batch?.item_id,
                from_bin_location: batch?.from_bin_location,
                to_bin_location: batch?.to_bin_location,
                from_bin_id: batch?.from_bin_id,
                to_bin_id: batch?.to_bin_id,
              })) ?? [],
        // item_unit_price: item?.item_unit_price,
        item_return_open_quantity:
          type === "view" || type === "edit"
            ? item?.item_credit_quanity_remaining
            : item?.item_to_be_received ?? item?.item_credit_quanity_remaining ?? 0,
        quantity: item?.item_quantity,
        item_pack_size: item?.item_pack_size || 0,
        base_quantity: item?.base_quantity || 0,
        item_free_quantity: parseInt(item?.item_free_quantity) || 0,
        item_discount_amount:
          type === "return" ? 0 : item?.item_discount_amount || 0,
        item_tax_amount: type === "return" ? 0 : item?.item_tax_amount || 0,
        item_total_amount: type === "return" ? 0 : item?.item_total_amount || 0,
        item_id: item?.item_id,
        pot_id: item?.pot_id ?? null,
        gort_id: item?.gort_id ?? null,
        item_gst: parseFloat(item?.item_gst),
        item_sgst: parseFloat(item?.item_sgst||0),
        item_cgst: parseFloat(item?.item_cgst||0),
        item_igst: parseFloat(item?.item_igst||0),
        item_uom_id: item?.item_uom_id,
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
              base_quantity: uom?.base_quantity ?? 1,
            }))
          : [],
      })),
      initialData,
    ],
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code is required"),
    cmr_name: Yup.object().required("Customer name is required"),
    data: Yup.array().of(
      Yup.object().shape({
        item_batches: Yup.array().of(
          Yup.object().shape({
            item_batch_purchase_rate: Yup.number()
              .typeError("Must be a number")
              .required("Purchase rate is required")
              .moreThan(0, "Purchase rate must be greater than 0"),

            item_batch_unit_price: Yup.number()
              .typeError("Must be a number")
              .required("MRP is required")
              .moreThan(0, "MRP must be greater than 0")
              .test(
                "MRP-greater-than-final-purchase-rate",
                "MRP must be greater than the final purchase rate",
                function (value) {
                  const { item_batch_final_purchase_rate } = this?.parent;
                  return value > item_batch_final_purchase_rate;
                }
              ),
            item_sellable_quantity: Yup.number()
              .typeError("Must be a number")
              .integer("Quantity must be an integer")
              .required("Sellable quantity is required")
              .moreThan(0, "Sellable quantity must be greater than 0"),
            item_batch_free_quantity: Yup.number()
              .transform((value) =>
                typeof value === "string" ? parseInt(value, 10) : value
              ) // Transform string to number
              .typeError("Must be a number")
              .integer("Quantity must be an integer"),
            item_batch_number: Yup.string().required(
              "Batch number is required"
            ),
            // to_bin_id: Yup.string().required("Bin ID is required"),
            item_exp_date: Yup.date().required("Expiration date is required"),
          })
        ),
      })
    ),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    dispatch(binLocationListAction(onSuccessBin, onerrorBin));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const PurRetdata = parsed.find((obj) => obj?.purchase_return_create);
      if (PurRetdata?.purchase_return_create) {
        setHeading(PurRetdata.purchase_return_create);
      }
    }
  }, []);

  const onSuccessBin = (data) => {
    setBinLocationList(
      data?.data?.map((item) => ({
        label: (
          <span
            className={`${
              item?.is_expired_bin_location ||
              item?.is_non_sellable_bin_location
                ? "text-F51D00"
                : ""
            }`}
          >
            {item?.bin_location_no}
            {item?.is_expired_bin_location}
            {item?.is_non_sellable_bin_location}
          </span>
        ),
        value: item?.bin_no_id,
        actualLabel: item?.bin_location_no,
      }))
    );
  };
  const onerrorBin = () => {};
  const onSuccessStore = (data) => {
    setLoading(false);
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {
    setLoading(false);
  };
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils")
        return;
    }
  };
  const onErrorStoreDetails = () => {};
  const handleSubmit = (values, actions) => {
    let actionType = purchaseReturnReceiptCreateAction;

    if (page === "edit") {
      actionType = purchaseReturnEditAction;
    }

    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.prt_order_status !== "draft"
    ) {
      setButtonLoading(true);

      dispatch(
        purchaseReturnEditAction(
          {
            is_draft_order: values.submittedButton === "draft" ? true : false,
            only_remarks: true,
            prt_id: values?.prt_id,
            remarks: values?.remarks,
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values.data
          ?.slice(0, -1)
          ?.some((item) => item.item_batches.length === 0) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Please add batches for all items");
      } else if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if(!values?.prt_pay_to_address){
          errorToast("Please verify and save the address");
          return;
        }
        if(!values?.prt_ship_to_address){
          errorToast("Please verify and save the address");
          return;
        }
        if (values?.data?.length > 1) {
          setButtonLoading(true);
          dispatch(
            actionType(
              {
                orderData: {
                  is_draft_order:
                    values.submittedButton === "draft" ? true : false,
                  store_id: storeId,
                  ...(values?.prt_id ? { prt_id: values?.prt_id } : {}),

                  prt_total_gst: values?.prt_total_gst || 0,
                  prt_total_discount: values?.prt_total_discount || 0,
                  prt_payment_status: "paid",
                  prt_transaction_id: "",
                  prt_billing_address: "",
                  prt_sub_total: values?.prt_sub_total || 0,
                  prt_total_amount: values?.prt_total_amount || 0,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  // prt_order_date: values?.prt_order_date,
                  prt_document_date: values?.prt_document_date,
                  prt_delivery_date: values?.prt_delivery_date,
                  prt_round_off_value: values?.prt_round_off_value || 0,
                  prt_tcs_or_tds_percentage_id:
                    values?.prt_tcs_or_tds_percentage_id ?? "",
                  prt_tcs_or_tds_percentage:
                    values?.prt_tcs_or_tds_percentage || 0,
                  prt_tds_tcs_type: values?.prt_tds_tcs_type ?? "",
                  prt_tcs_or_tds_amount: values?.prt_tcs_or_tds_amount || 0,
                  prt_is_invoice_dis_percentage:
                    values?.prt_is_invoice_dis_percentage,
                  prt_invoice_discount: values?.prt_invoice_discount,
                  prt_invoice_discount_percentage:
                    values?.prt_invoice_discount_percentage,
                  prt_pay_to_address: values?.prt_pay_to_address || null, //new
                  prt_ship_to_address: values?.prt_ship_to_address || null, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter",
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_id: item?.item_id,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_uom: item?.item_uom,
                  ...(values?.prt_id ? { prt_id: values?.prt_id } : {}),
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_quantity: parseInt(item?.quantity),
                  item_pack_size: parseFloat(item.item_pack_size),
                  item_free_quantity: item?.item_batches?.reduce(
                    (sum, batch) =>
                      sum + (parseInt(batch.item_batch_free_quantity, 10) || 0),
                    0
                  ),
                  // item_received_quantity: parseInt(item?.quantity),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_tax_amount: item?.item_tax_amount || 0,
                  item_discount_amount: item?.item_discount_amount || 0,
                  item_gst: item?.item_gst,
                  item_cgst: values?.is_inter_state===false?(item?.item_cgst):0,
                  item_sgst: values?.is_inter_state===false?(item?.item_sgst):0,
                  item_igst: values?.is_inter_state===true?(item?.item_igst):0,
                  // ...(item?.pot_id ? { pot_id: item?.pot_id } : {}),
                  ...(item?.gort_id
                    ? { gort_id: item?.gort_id }
                    : { gort_id: null }),
                  item_uom_id: item?.item_uom_id,
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    ...(values?.prt_id ? { prt_id: values?.prt_id } : {}),
                    item_sellable_quantity:
                      parseInt(batch?.item_sellable_quantity) || 0,
                    item_batch_free_quantity:
                      batch?.item_batch_free_quantity || 0,
                    item_batch_total_effective_qauntity:
                      parseInt(batch?.item_batch_total_effective_qauntity) || 0, //new
                    item_batch_purchase_rate: batch?.item_batch_purchase_rate,

                    item_batch_total_base_purchase_rate:
                      parseFloat(batch?.item_batch_total_base_purchase_rate) ??
                      0, //new

                    item_batch_for_qauntity:
                      parseInt(batch?.item_batch_for_qauntity) || 0, //new
                    item_batch_for_free_qauntity:
                      parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                    item_batch_scheme_discount_percentage:
                      parseFloat(
                        batch?.item_batch_scheme_discount_percentage
                      ) || 0, //new
                    item_batch_scheme_discount_amount:
                      parseFloat(batch?.item_batch_scheme_discount_amount) || 0, //new

                    item_batch_scheme_purchase_rate:
                      parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new

                    item_batch_discount_percentage:
                      parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                    item_batch_gen_discount_amount:
                      parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                    item_batch_discounted_purchase_rate:
                      parseFloat(batch?.item_batch_discounted_purchase_rate) ??
                      0, //new
                    item_batch_margin_percentage:
                      parseFloat(batch?.item_batch_margin_percentage) || 0,
                    item_batch_discount_amount:
                      batch?.item_batch_discount_amount,
                    item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: batch?.item_batch_tax_amount,
                    item_batch_final_purchase_rate:
                      batch?.item_batch_final_purchase_rate,
                    item_batch_total_purchase_rate:
                      batch?.item_batch_total_purchase_rate,
                    item_batch_unit_price: batch?.item_batch_unit_price,
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    // from_bin_location: batch?.from_bin_location,
                    to_bin_location: batch?.to_bin_location,
                    // from_bin_id: batch?.from_bin_id,
                    to_bin_id: batch?.to_bin_id,
                    item_batch_cgst_percentage:values?.is_inter_state===false?(batch?.item_batch_cgst_percentage||0):0,
                    item_batch_sgst_percentage:values?.is_inter_state===false?(batch?.item_batch_sgst_percentage||0):0,
                    item_batch_igst_percentage:values?.is_inter_state===true?(batch?.item_batch_igst_percentage||0):0,
                    item_batch_cgst_amount:values?.is_inter_state===false?(batch?.item_batch_cgst_amount||0):0,
                    item_batch_sgst_amount:values?.is_inter_state===false?(batch?.item_batch_sgst_amount||0):0,
                    item_batch_igst_amount:values?.is_inter_state===true?(batch?.item_batch_igst_amount||0):0,
                  })),
              },
              onSuccessOrder,
              onErrorOrder
            )
          );
        }
      }
    }
  };

  const onSuccessOrder = (data) => {
    setButtonLoading(false);
    navigate("/purchase-return");
    if (formValues?.submittedButton === "print") {
      const prtId =
        data?.data?.orderData?.prt_id ?? data?.data?.orderData?.[0]?.prt_id;
      if (prtId) {
        handlea4Print(prtId, "purchase_return", dispatch);
      }
      // downloadPdf(data?.data);
    }
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      remarks: "",
      prt_total_discount: 0,
      prt_order_date: null,
      prt_document_date: null,
      prt_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = (data) => {
    setButtonLoading(false);
    errorToast(data?.data?.message);
  };
  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  const autoDraft = (values) => {
    let actionType = purchaseReturnReceiptCreateAction;

    if (page === "edit") {
      actionType = purchaseReturnEditAction;
    }

    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.prt_order_status !== "draft"
    ) {
      setButtonLoading(true);

      dispatch(
        purchaseReturnEditAction(
          {
            is_draft_order: true,
            only_remarks: true,
            prt_id: values?.prt_id,
            remarks: values?.remarks,
          },
          (data) => {
            successToast(data?.message);
            // setLoading(true);
            setTimeout(() => {
              // setLoading(false);
            }, 50);
            navigate(
              `/edit-customer-admin/${values?.cmr_id}?backto=/edit-purchase-return/${data?.data?.orderData?.[0]?.prt_id}?new`,
              {
                state: { tab: "Address" },
              }
            );
          },
          (data) => {
            errorToast(data?.data?.message);
          }
        )
      );
    } else {
      if (
        values.data
          ?.slice(0, -1)
          ?.some((item) => item.item_batches.length === 0) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Please add batches for all items");
      } else if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if (values?.data?.length > 1) {
          setButtonLoading(true);
          dispatch(
            actionType(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: storeId,
                  ...(values?.prt_id ? { prt_id: values?.prt_id } : {}),

                  prt_total_gst: values?.prt_total_gst || 0,
                  prt_total_discount: values?.prt_total_discount || 0,
                  prt_payment_status: "paid",
                  prt_transaction_id: "",
                  prt_billing_address: "",
                  prt_sub_total: values?.prt_sub_total || 0,
                  prt_total_amount: values?.prt_total_amount || 0,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  // prt_order_date: values?.prt_order_date,
                  prt_document_date: values?.prt_document_date,
                  prt_delivery_date: values?.prt_delivery_date,
                  prt_round_off_value: values?.prt_round_off_value || 0,
                  prt_tcs_or_tds_percentage_id:
                    values?.prt_tcs_or_tds_percentage_id ?? "",
                  prt_tcs_or_tds_percentage:
                    values?.prt_tcs_or_tds_percentage || 0,
                  prt_tds_tcs_type: values?.prt_tds_tcs_type ?? "",
                  prt_tcs_or_tds_amount: values?.prt_tcs_or_tds_amount || 0,
                  prt_is_invoice_dis_percentage:
                    values?.prt_is_invoice_dis_percentage,
                  prt_invoice_discount: values?.prt_invoice_discount,
                  prt_invoice_discount_percentage:
                    values?.prt_invoice_discount_percentage,
                  prt_pay_to_address: values?.prt_pay_to_address || null, //new
                  prt_ship_to_address: values?.prt_ship_to_address || null, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter",
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_id: item?.item_id,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_uom: item?.item_uom,
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_quantity: parseInt(item?.quantity),
                  item_pack_size: parseFloat(item.item_pack_size),
                  item_free_quantity: item?.item_batches?.reduce(
                    (sum, batch) =>
                      sum + (parseInt(batch.item_batch_free_quantity, 10) || 0),
                    0
                  ),
                  // item_received_quantity: parseInt(item?.quantity),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_tax_amount: item?.item_tax_amount || 0,
                  item_discount_amount: item?.item_discount_amount || 0,
                  item_gst: item?.item_gst,
                  item_cgst: values?.is_inter_state===false?(item?.item_cgst):0,
                  item_sgst: values?.is_inter_state===false?(item?.item_sgst):0,
                  item_igst: values?.is_inter_state===true?(item?.item_igst):0,
                  // ...(item?.pot_id ? { pot_id: item?.pot_id } : {}),
                  ...(item?.gort_id && type === "goods"
                    ? { gort_id: item?.gort_id }
                    : { gort_id: null }),
                  item_uom_id: item?.item_uom_id,
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_sellable_quantity:
                      parseInt(batch?.item_sellable_quantity) || 0,
                    item_batch_free_quantity:
                      batch?.item_batch_free_quantity || 0,
                    item_batch_total_effective_qauntity:
                      parseInt(batch?.item_batch_total_effective_qauntity) || 0, //new
                    item_batch_purchase_rate: batch?.item_batch_purchase_rate,

                    item_batch_total_base_purchase_rate:
                      parseFloat(batch?.item_batch_total_base_purchase_rate) ??
                      0, //new

                    item_batch_for_qauntity:
                      parseInt(batch?.item_batch_for_qauntity) || 0, //new
                    item_batch_for_free_qauntity:
                      parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                    item_batch_scheme_discount_percentage:
                      parseFloat(
                        batch?.item_batch_scheme_discount_percentage
                      ) || 0, //new
                    item_batch_scheme_discount_amount:
                      parseFloat(batch?.item_batch_scheme_discount_amount) || 0, //new

                    item_batch_scheme_purchase_rate:
                      parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new

                    item_batch_discount_percentage:
                      parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                    item_batch_gen_discount_amount:
                      parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                    item_batch_discounted_purchase_rate:
                      parseFloat(batch?.item_batch_discounted_purchase_rate) ??
                      0, //new
                    item_batch_margin_percentage:
                      parseFloat(batch?.item_batch_margin_percentage) || 0,
                    item_batch_discount_amount:
                      batch?.item_batch_discount_amount,
                    item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: batch?.item_batch_tax_amount,
                    item_batch_final_purchase_rate:
                      batch?.item_batch_final_purchase_rate,
                    item_batch_total_purchase_rate:
                      batch?.item_batch_total_purchase_rate,
                    item_batch_unit_price: batch?.item_batch_unit_price,
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    // from_bin_location: batch?.from_bin_location,
                    to_bin_location: batch?.to_bin_location,
                    // from_bin_id: batch?.from_bin_id,
                    to_bin_id: batch?.to_bin_id,
                    item_batch_cgst_percentage:values?.is_inter_state===false?(batch?.item_batch_cgst_percentage||0):0,
                    item_batch_sgst_percentage:values?.is_inter_state===false?(batch?.item_batch_sgst_percentage||0):0,
                    item_batch_igst_percentage:values?.is_inter_state===true?(batch?.item_batch_igst_percentage||0):0,
                    item_batch_cgst_amount:values?.is_inter_state===false?(batch?.item_batch_cgst_amount||0):0,
                    item_batch_sgst_amount:values?.is_inter_state===false?(batch?.item_batch_sgst_amount||0):0,
                    item_batch_igst_amount:values?.is_inter_state===true?(batch?.item_batch_igst_amount||0):0,
                  })),
              },
              (data) => {
                successToast(data?.message);
                // setLoading(true);
                setTimeout(() => {
                  // setLoading(false);
                }, 50);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-purchase-return/${data?.data?.orderData?.prt_id}?new`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                errorToast(data?.data?.message);
              }
            )
          );
        }
      }
    }
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            handleSubmit(values, actions); // Pass values and actions if needed
            actions.setSubmitting(false); // Notify Formik that submission is done
          }, 500);
        }}
      >
        {({ values, setFieldValue }) => {
          setFormValues(values);
          return (
            <Form className="h-full">
              <PurchaseBatchesPanel
                prefix="prt"
                open={addbatch}
                disabled={disabled}
                disName="prt_total_discount"
                binLocationList={binLocationList}
                setItemId={setItemId}
                itemId={itemId}
                setOpen={setAddbatch}
                itemValues={values}
              />

              <div
                style={{
                  height: `calc(100% - 8rem)`,
                }}
                className="mx-5 flex flex-col h-full "
              >
                <SalesPurchaseNavbar
                  isClone={isClone}
                  transfer={transfer}
                  autoDraft={autoDraft}
                  clickedplus={clickedplus}
                  pageType={pageType}
                  page={page}
                  isCusInvNumRequired={false}
                  csvButtonText="Import CSV"
                  importcsv={false}
                  section="purchase"
                  name="prt"
                  disabled={disabled}
                  searchRef={searchRef}
                  storeDetails={storeDetails}
                  standAlone={!transfer}
                />

                <PurchaseItemsSection
                  heading={heading}
                  prefixName="prt"
                  disabled={values.is_inter_state===null || disabled}
                  addBatchFn={(id) => {
                    setAddbatch(true);
                    setItemId(id);
                  }}
                  searchRef={searchRef}
                  initialData={initialData}
                />
              </div>

              <SalesPurchaseFooter
                EditFn={() => {
                  navigate(`/edit-purchase-return/${values?.prt_id}`);
                }}
                formValuesRef={formValuesRef}
                transaction="Purchase Return"
                transaction_type="purchase_return"
                buttonLoading={buttonLoading}
                name="prt_total_discount"
                page={page}
                disabled={disabled}
                prefixName="prt"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewPurReturn;
